import { QueryClient } from '@tanstack/react-query'

import { ApiError } from './problem'

/**
 * Fælles opsætning af TanStack Query.
 *
 * Vigtigste valg: vi prøver ikke igen på klientfejl. En 403 bliver ikke til en
 * 200 af at blive gentaget – det giver kun langsommere fejlbeskeder og
 * unødig belastning.
 */
function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError) {
            return error.isRetryable && failureCount < 2
          }
          return failureCount < 2
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        // Mutationer gentages aldrig automatisk: de kan have sideeffekter,
        // og en dublet-upload er værre end en fejlbesked.
        retry: false,
      },
    },
  })
}

/**
 * Én klient for hele appen — som modul-singleton og ikke i React-state.
 *
 * Auth-storen lever uden for React-træet og skal kunne rydde cachen ved
 * logout og organisationsskifte. Ellers ville den forrige brugers — eller den
 * forrige organisations — data blive stående og serveret fra cachen.
 */
export const queryClient = createQueryClient()
